<app-type-cr-jugement
  [uid]="getUid()"
  [parentForm]="parentForm"
  [disabled]="disabled"
  [criteresAttribution]="criteresAttribution"
></app-type-cr-jugement>
